// I.157 teto 1.000: o servidor (PostgREST) devolve no máximo 1.000 linhas por consulta.
// Busca em lotes de 1.000 com .range() até um lote vir incompleto. Quem chama monta a
// consulta do zero a cada lote, com ordem determinística terminando em 'id', para
// nenhuma linha repetir nem faltar entre os lotes (mesmo molde do m-LOC.12).
export const SERVER_PAGE_SIZE = 1000;

export async function fetchAllRows<T>(
  fetchPage: (from: number, to: number) => PromiseLike<{ data: T[] | null; error: unknown }>
): Promise<T[]> {
  const rows: T[] = [];
  for (let from = 0; ; from += SERVER_PAGE_SIZE) {
    const { data, error } = await fetchPage(from, from + SERVER_PAGE_SIZE - 1);
    if (error) throw error;
    rows.push(...(data ?? []));
    if (!data || data.length < SERVER_PAGE_SIZE) break;
  }
  return rows;
}
